var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.href ? 'a' : 'div',{tag:"component",staticClass:"ui-back",class:[
        `_theme_${_vm.theme}`,
        { _no_text: _vm.noText },
    ],attrs:{"href":_vm.href ? _vm.href : null},on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"ui-back__icon"},[_c('icon',{attrs:{"name":"caret-left"}})],1),(!_vm.noText)?_c('div',{staticClass:"ui-back__text",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }